import React, {
  useEffect,
  useState
} from 'react';

import PropTypes from 'prop-types';

import {
  FormFieldLabel,
  RedButton
} from 'src/StyledComponents';

import
VettingInput
from 'src/Components/Common/VettingInput/VettingInput';

import {
  createArray,
  checkInputValidity,
  isMobileView
} from 'src/Utility/utility';

import {
  tagOnCampaignFormStarted
} from 'src/Tagging/SalesCampaignTagging';

import {
  getEnv
} from 'src/Utility/utility';

import VettingDropDown from 'src/Components/Common/VettingDropDown/VettingDropDown';

import './LeadsForm.css';

const personalDetailsData = {},
  contactDetailsData = {};

const OptionalInputText = () => {

  return (
    <span
      style={{
        marginLeft: '5px',
        fontSize: '12px',
        color: '#999'
      }}>

      (Optional)
    </span>
  );
};

const LeadsForm = (props) => {

  const [ formData, setFormData ] = useState({
    formComponents: {
      firstName: {
        name: 'First name',
        type: 'input',
        value: personalDetailsData?.firstName?.value || '',
        width: 50,
        validations: {
          required: true,
          minLength: 2,
          maxLength: 50,
          specialText: true,
          invalidMessage: !props.isNewForm && 'Please enter a valid last name'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'eg. John',
          tabIndex: '1'
        },
        isValid: false,
        isTouched: false
      },
      surname: {
        name: 'Last name',
        type: 'input',
        value: personalDetailsData?.surname?.value || '',
        width: 50,
        validations: {
          required: true,
          minLength: 2,
          maxLength: 50,
          specialText: true,
          invalidMessage: !props.isNewForm && 'Please enter a valid last name'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'eg. Smith',
          tabIndex: '2'
        },
        isValid: false,
        isTouched: false
      },
      cellPhoneNo: {
        name: 'Cellphone number',
        type: 'input',
        value: contactDetailsData?.cellPhoneNo?.value || '',
        width: 50,
        validations: {
          type: 'cellphoneNo',
          required: true,
          invalidMessage: props.isNewForm ? 'Invalid cellphone number' : 'Please enter a valid cellphone number'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'eg. 082 123 4567',
          tabIndex: '3'
        },
        isValid: false,
        isTouched: false,
        ...(props.isNewForm ? { note: 'We’ll call you on this number' } : {})
      },
      email: {
        name: 'Email address',
        type: 'input',
        value: contactDetailsData?.email?.value || '',
        width: 50,
        validations: {
          type: 'email',
          required: true,
          maxLength: 500,
          invalidMessage: props.isNewForm ? 'Invalid email address' : 'Please enter a valid email address'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'eg. john@gmail.com',
          tabIndex: '4'
        },
        isValid: false,
        isTouched: false
      },
      preferredTime: {
        name: 'At what time can we call you? (Optional)',
        type: 'dropDown',
        value: '',
        options: [ 'Anytime',
          '08:00  - 10:00',
          '10:00  - 12:00',
          '12:00  - 14:00',
          '14:00  - 16:00',
          '16:00  - 18:00',
          '18:00  - 20:00' ],
        width: 50,
        validations: {
          required: false,
          invalidMessage: 'Please select a valid slot'
        },
        config: {
          type: 'select',
          required: false,
          placeholder: 'Please select a time slot',
          tabIndex: '5'
        },
        isValid: true,
        isTouched: false
      }
    },
    isFormValid: false,
    formSubmitAttempt: 0,
    hasError: false
  });

  const [ instructionsData, setInstructionsData ] = useState('');
  const [ isApiError, setIsApiError ] = useState(false);
  const [ isFormTouched, setIsFormTouched ] = useState(false);

  useEffect(() => {

    setIsApiError(props.apiError);
  }, [ props.apiError ]);

  const formComponentChangeHandler = (event, inputIdentifier) => {

    if (isApiError) {
      setIsApiError(false);
    }
    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = { ...formCompsCopy[inputIdentifier] };
    changedComponent.value = event;

    if (changedComponent.validations.type === 'number') {

      let lastChar = changedComponent.value.slice(-1);
      if (isNaN(lastChar)) {
        return false;
      }
    }

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    if (!changedComponent.config.required && changedComponent.value === '') {
      changedComponent.isValid = true;
    }

    changedComponent.isTouched = true;

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent
    };

    const isFormValid = !Object.keys(newFormComps).find(
      (e) => newFormComps[e].isValid === false
    )
      ? true
      : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });

    if (!isFormTouched) {
      tagOnCampaignFormStarted();
      setIsFormTouched(true);
    }
  };

  const instructionsDataChangeHandler = (event) => {
    setInstructionsData(event.target.value);
  };

  const submitForm = () => {

    if (formData.isFormValid) {

      const submitFormData = {
        contactFirstName: formData.formComponents.firstName.value.trim(),
        contactLastName: formData.formComponents.surname.value.trim(),
        contactMobilePhoneNumber: formData.formComponents.cellPhoneNo.value.trim(),
        contactEmailAddress: formData.formComponents.email.value.trim(),
        preferredTime: formData.formComponents.preferredTime.value.trim(),
        additionalNotes: typeof instructionsData !== 'string' ? '' : instructionsData.trim()
      };
      props.onSubmit(submitFormData);
    }
  };

  const formCompArray = createArray(formData.formComponents);

  return (
    <div
      className={props.isNewForm ? 'deals-for-ftths-new-form-container' : 'deals-for-ftths-form-container'}>

      {/* <div style={{}}>
        <Subtitle
          style={{ fontSize: "18px", display: "flex", alignItems: "center" }}
        >
          <PersonIcon strokeColor="#282828" />
          <span style={{ marginLeft: "10px" }}>Personal information</span>
        </Subtitle>
      </div>
      <HorizontalLine /> */}

      <div className="deals-for-ftths-form-inputs-container">

        <div className="deals-for-ftths-form-input-container">

          {formCompArray.map((item) => {

            return (

              <div className="deals-for-ftths-form-input-wrapper" key={item.key}>

                {item.config.type === 'input' &&

                  <div style={{paddingTop: item.key === 'email'  && isMobileView() ? '24px' : '0'}}>

                    <FormFieldLabel
                      hide={item?.config?.hideLabel}
                      automationidattr={`leadsForm${ item.config.name }`}>

                      {item.config.name}
                    </FormFieldLabel>

                    <VettingInput
                      {...item.config}
                      updateValue={formComponentChangeHandler}
                      inputIdentifier={item.key}
                      automationidattr={'leadsForm'}
                      isNewForm={true} />

                  </div>

                }

              </div>
            );
          })}
        </div>

        {props.isNewForm
          ? (
            <div className="deals-for-ftths-new-form-text-area-wrapper" style={{marginTop: isMobileView() && '0'}}>

              <FormFieldLabel automationidattr={'leadsForm_instructions'}>
                <span>At what time can we call you?</span>

                <OptionalInputText />
              </FormFieldLabel>

              {formCompArray.map((item, index) => {

                return (

                  <div
                    key={index}
                    className="deals-for-ftths-form-dropdown-wrapper">

                    {item.config.type === 'dropDown' &&

                      <VettingDropDown
                        selectedValue={item.config.value}
                        placeholder={props.isNewForm ? '- Select an option -' : item.config.config.placeholder}
                        options={item.config.options}
                        updateSelectedOption={formComponentChangeHandler}
                        inputIdentifier={item.key}
                        addClass={'deals-for-ftths-form-dropdown-wrapper'}
                        automationidattr={item.key} />
                    }

                  </div>
                );
              })}

            </div>
          )
          : (
            <div className="deals-for-ftths-form-text-area-wrapper">

              <FormFieldLabel automationidattr={'leadsForm_instructions'}>
                <span>Anything you would like to add?</span>

                <OptionalInputText />
              </FormFieldLabel>

              <textarea
                className="deals-for-ftths-form-textarea"
                onChange={instructionsDataChangeHandler}
                value={instructionsData}
                placeholder={props.isNewForm ? 'Im looking for...' : 'Type here...'}
                tabIndex="5" />

            </div>
          )
        }
        {!props.isNewForm
          ? (
            <div className="deals-for-ftths-form-text-area-wrapper">

              <FormFieldLabel automationidattr={'leadsForm_instructions'}>
                <span>At what time can we call you?</span>

                <OptionalInputText />
              </FormFieldLabel>

              {formCompArray.map((item, index) => {

                return (

                  <div
                    key={index}
                    className="deals-for-ftths-form-dropdown-wrapper">

                    {item.config.type === 'dropDown' &&

                      <VettingDropDown
                        selectedValue={item.config.value}
                        placeholder={props.isNewForm ? '- Select an option -' : item.config.config.placeholder}
                        options={item.config.options}
                        updateSelectedOption={formComponentChangeHandler}
                        inputIdentifier={item.key}
                        addClass={'deals-for-ftths-form-dropdown-wrapper'}
                        automationidattr={item.key} />
                    }

                  </div>
                );
              })}

            </div>
          )
          : (
            <div className="deals-for-ftths-new-form-text-area-wrapper" style={{marginTop: '0'}}>

              <FormFieldLabel automationidattr={'leadsForm_instructions'}>
                <span>Anything you would like to add?</span>

                <OptionalInputText />
              </FormFieldLabel>

              <textarea
                className="deals-for-ftths-form-textarea"
                onChange={instructionsDataChangeHandler}
                value={instructionsData}
                placeholder={props.isNewForm ? 'Im looking for...' : 'Type here...'}
                tabIndex="5" />

            </div>
          )
        }

      </div>

      <div className={props.isNewForm ? 'deals-for-ftths-new-form-submit-wrapper' : 'deals-for-ftths-form-submit-wrapper'}>

        <RedButton
          automationid="SalesLead_Button_FtthsDealsFormSubmit_01"
          disabled={!formData.isFormValid || isApiError}
          borderRadius={'50px'}
          padding={props.isNewForm ? '12px 16px' : '16px 12px'}
          onClick={submitForm}>

          {props.isNewForm ? 'Give me a call' : 'Get a quote'}
        </RedButton>

        {props.isNewForm &&
          <div className='deals-for-ftths-new-form-link'>Want to explore plans yourself?

            <a href={`https://www${ getEnv() }.vodacom.co.za/vodacom/fibre/sales/leads`}
              target="_blank"
              style={{textDecoration: 'none', padding: '4px'}}
              rel="noopener noreferrer">
              Browse online
            </a>
          </div>
        }
      </div>
    </div>
  );
};

LeadsForm.propTypes = {
  isNewForm: PropTypes.bool,
  onSubmit: PropTypes.func,
  apiError: PropTypes.string
};

export default LeadsForm;